<label class="switch">
    <input
        (change)="toggleState()"
        (click)="$event.stopPropagation()"
        [checked]="checked"
        [disabled]="readonly || disabled"
        [readonly]="readonly || disabled"
        type="checkbox"
    />
    <span [class.toggle-blue]="!disabled && color === 'blue'" [class.toggle-disabled]="disabled" [class.toggle-green]="!disabled && color === 'green'"></span>
</label>
